import { LinearProgress } from '@mui/material';
import LangEnum from '../../../lang/LangEnum';
import MyNetworkListEmptyState from '../components/MyNetworkListEmptyState';
import { MyNetworkTabProps } from '../myNetwork.types';
import MyNetworkExploreGrid from './MyNetworkExploreGrid';
import useMyNetworkExploreList from './hooks/useMyNetworkExploreList';

const MyNetworkExploreList = ({ updateNotifications }: MyNetworkTabProps) => {
  const { explores, isLoading, isEmpty, hasNextPage, sentinelRef, reload } =
    useMyNetworkExploreList();

  if (isEmpty) {
    return (
      <MyNetworkListEmptyState
        title={LangEnum.MY_NETWORK_EXPLORE_EMPTY}
        description={LangEnum.MY_NETWORK_EXPLORE_EMPTY_DESCRIPTION}
      />
    );
  }

  return (
    <>
      <MyNetworkExploreGrid
        items={explores}
        reload={reload}
        updateNotifications={updateNotifications}
        loadMoreSentinel={hasNextPage && <div ref={sentinelRef} />}
      />
      {isLoading && <LinearProgress />}
    </>
  );
};

export default MyNetworkExploreList;
